import { createServerFn, createServerOnlyFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { queryOptions } from "@tanstack/react-query";

// Extraída do handler e marcada server-only (createServerOnlyFn não depende
// de Start context, ao contrário de createServerFn — chamável direto em
// teste): createServerFn lança "No Start context found" quando chamada fora
// de uma requisição real, então testar a const exportada diretamente
// quebra — mesmo motivo documentado em addresses.functions.ts. Precisa do
// wrapper (em vez de uma função solta) porque este módulo também é
// importado por rotas client-side, e getRequest é uma API server-only.
export const resolveRequestOrigin = createServerOnlyFn((): string => {
  const request = getRequest();
  return new URL(request.url).origin;
});

export const getRequestOrigin = createServerFn({ method: "GET" }).handler(async () =>
  resolveRequestOrigin(),
);

// staleTime: Infinity — a origem não muda durante a sessão, então uma única
// chamada é reaproveitada por todas as rotas indexáveis.
export const requestOriginQuery = () =>
  queryOptions({
    queryKey: ["request-origin"],
    queryFn: () => getRequestOrigin(),
    staleTime: Infinity,
  });
